import './list_title_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  static values = {
    id: String
  }

  open = (): void => {
    this.layoverController().load(this.idValue, 'show')
  }

  layoverController = (node: object): object => {
    return this.application.getControllerForElementAndIdentifier(document.getElementById('layover'), 'layover')
  }
}
